<template>
  <div class="material-memo">
    <div class="memo-title" v-text="memoTitle"></div>
    <ul class="memo-list">
      <li class="memo-item" v-for="(memo, index) in memoArr" :key="index">
        <i class="dot" v-if="memoArr.length > 1 && memo">•</i>
        <span class="memo-detail" v-text="memo"></span>
      </li>
    </ul>
  </div>
</template>

<script>
import uploadFileService from '../../services/upload-file-service';

export default {
  name: 'material-memo',
  props: {
    memoContent: {
      type: String,
      required: true,
    },
    memoTitle: {
      type: String,
      default: '预审不合格',
    },
  },
  data() {
    return {
      memoArr: uploadFileService.makeStringList(this.memoContent),
    };
  },
  watch: {
    memoContent(newVal) {
      this.memoArr = uploadFileService.makeStringList(newVal);
    },
  },
};
</script>

<style lang="less" scoped>
@import '../../assets/less/variable';
.material-memo {
  padding: 20px 20px 15px 20px;
  background-color: #fef7f8;
  border-radius: 4px;
  font-size: 14px;
  color: @text-red;
  .memo-title {
    line-height: 14px;
    font-weight: bold;
  }
  .memo-list {
    margin-top: 5px;
  }
  .memo-item {
    display: flex;
    font-size: 14px;
    line-height: 24px;
  }
  .dot {
    width: 12px;
  }
  .memo-detail {
    flex: 1;
    word-break: break-all;
  }
}
</style>




// WEBPACK FOOTER //
// src/components/upload/memo.vue